import {executorsRegistry} from "./marketingExecutors/ExecutorsRegistry";

/**
 * Запускает события которые должны выполниться на текущей странице с pageId.
 * сервис прослойка.
 * @param {string} pageId - Идентификатор страницы.
 */
export function biMarketingEventPageExecutor(pageId) {
    if (executorsRegistry[pageId] && typeof executorsRegistry[pageId].run === 'function') {
         executorsRegistry[pageId].run();
    } else {
        // console.info('Executor для страницы не найден:', pageId);
    }
}